import {
  FaTwitter,
  FaLinkedin,
  FaYoutube,
  FaGithub,
  FaDiscord,
  FaTwitch,
} from "react-icons/fa"
import { Footer as FlowbiteFooter } from "flowbite-react"
import HT_TRAINING_logo_letters_horiz_big from "../assets/images/HT_TRAINING_logo_letters_horiz_big.svg"
import { Link } from "react-router-dom"

const Footer = () => {
  return (
    <FlowbiteFooter
      container={true}
      className="!bg-neutral-900 !dark:bg-neutral-900 rounded-b-none"
    >
      <div className="container mx-auto">
        <div className="w-full">
          <div className="grid w-full justify-between sm:flex sm:justify-between md:flex md:grid-cols-1">
            <div>
              <Link to="/">
                <img
                  src={HT_TRAINING_logo_letters_horiz_big}
                  className="mr-3 h-24 sm:h-24"
                  alt="HackTricks Training Logo"
                />
              </Link>
            </div>
            <div className="grid grid-cols-2 gap-8 mt-10 sm:mt-4 sm:grid-cols-2 sm:gap-6 md:grid-cols-4">
              <div>
                <FlowbiteFooter.Title title="Courses" className="text-white" />
                <FlowbiteFooter.LinkGroup col={true}>
                  {/* TODO make this dynamic ? */}
                  <FlowbiteFooter.Link
                    href="/courses/arte"
                    className="text-white"
                  >
                    ARTE
                  </FlowbiteFooter.Link>
                </FlowbiteFooter.LinkGroup>
              </div>
              <div>
                <FlowbiteFooter.Title title="About" className="text-white" />
                <FlowbiteFooter.LinkGroup col={true}>
                  {/* TODO this link should use the router needs changes to Flowbite */}
                  {/* <FlowbiteFooter.Link href="/about" className="text-white">
                    Who are we?
                  </FlowbiteFooter.Link> */}
                  {/* TODO this link should use the router needs changes to Flowbite */}
                  <FlowbiteFooter.Link href="/contact" className="text-white">
                    Get in touch
                  </FlowbiteFooter.Link>
                  {/* TODO this link should use the router needs changes to Flowbite */}
                  <FlowbiteFooter.Link href="/faqs" className="text-white">
                    FAQs
                  </FlowbiteFooter.Link>
                </FlowbiteFooter.LinkGroup>
              </div>
              <div>
                <FlowbiteFooter.Title
                  title="Resources"
                  className="text-white"
                />
                <FlowbiteFooter.LinkGroup col={true}>
                  <FlowbiteFooter.Link
                    href="https://book.hacktricks.xyz/"
                    className="text-white"
                  >
                    HackTricks
                  </FlowbiteFooter.Link>
                  <FlowbiteFooter.Link
                    href="https://cloud.hacktricks.xyz/"
                    className="text-white"
                  >
                    HackTricks Cloud
                  </FlowbiteFooter.Link>
                </FlowbiteFooter.LinkGroup>
              </div>
              <div>
                <FlowbiteFooter.Title title="Legal" className="text-white" />
                <FlowbiteFooter.LinkGroup col={true}>
                  {/* TODO this link should use the router needs changes to Flowbite */}
                  <FlowbiteFooter.Link href="/terms" className="text-white">
                    Terms & Conditions
                  </FlowbiteFooter.Link>
                  <FlowbiteFooter.Link href="/privacy" className="text-white">
                    Privacy Policy
                  </FlowbiteFooter.Link>
                </FlowbiteFooter.LinkGroup>
              </div>
            </div>
          </div>
          <FlowbiteFooter.Divider className="border-gray-700" />
          <div className="w-full sm:flex sm:items-center sm:justify-between">
            <FlowbiteFooter.Copyright href="#" by="HackTricks" year={2023} />
            <div className="mt-4 flex space-x-6 sm:mt-0 sm:justify-center">
              <FlowbiteFooter.Icon
                href="https://twitter.com/hacktricks_live"
                icon={FaTwitter}
                className="text-gray-500 hover:text-white"
              />
              <FlowbiteFooter.Icon
                href="https://www.linkedin.com/company/hacktricks/"
                icon={FaLinkedin}
              />
              <FlowbiteFooter.Icon
                href="https://www.twitch.tv/hacktricks_live"
                icon={FaTwitch}
                className="text-gray-500 hover:text-white"
              />
              <FlowbiteFooter.Icon
                href="https://www.youtube.com/@hacktricks_LIVE"
                icon={FaYoutube}
                className="text-gray-500 hover:text-white"
              />
              <FlowbiteFooter.Icon
                href="https://github.com/carlospolop/"
                icon={FaGithub}
                className="text-gray-500 hover:text-white"
              />
              <FlowbiteFooter.Icon
                href="https://discord.gg/hRep4RUj7f"
                icon={FaDiscord}
                className="text-gray-500 hover:text-white"
              />
            </div>
          </div>
        </div>
      </div>
    </FlowbiteFooter>
  )
}

export default Footer
